import { render } from "./comp-code-input.vue?vue&type=template&id=2c471376&scoped=true"
import script from "./comp-code-input.vue?vue&type=script&lang=js"
export * from "./comp-code-input.vue?vue&type=script&lang=js"

import "./comp-code-input.vue?vue&type=style&index=0&id=2c471376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c471376"]])

export default __exports__